import Vue from 'vue'
import Main from './main.vue'

let BindPhoneConstructor = Vue.extend(Main)

const BindPhone = (options, props) => {
  options = options || {}
  let data = Object.assign({}, options, {
    afterClose: vm => {
      if (typeof options?.afterClose === 'function') {
        options.afterClose()
      }
      // vm.$destroy()
    }
  })
  let instance = new BindPhoneConstructor({
    ...props,
    data: data
  })
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.visible = true
  return instance
}

export default BindPhone
